import {fromJS, Map, List} from "immutable";
import {
  SET_VIEW_CONTEXT, 
  CLEAR_VIEW_CONTEXT,
  SHOW_CONTEXTUAL_MENU,
  CLOSE_CONTEXTUAL_MENU
  } from "../actions/ViewActions";

const initialState = fromJS({
  context: "",
  title: "",
  panels: [],
  contextualMenuActive: false,
  contextualMenuItems: [],
  contextualMenuPos: {x: 0, y: 0}
})

export default function(state = initialState, action) {
  switch(action.type) {
    case SET_VIEW_CONTEXT:
      return setPanels(setContext(state, action.context, action.title));

    case CLEAR_VIEW_CONTEXT:
      return clearContext(state, action.context);

    case SHOW_CONTEXTUAL_MENU:
      return state.set("contextualMenuActive", true)
                  .set("contextualMenuItems", fromJS(action.items))
                  .set("contextualMenuPos", Map({x: action.x, y: action.y}));

    case CLOSE_CONTEXTUAL_MENU:
      return state.set("contextualMenuActive", false)
                  .set("contextualMenuItems", List())
                  .set("contextualMenuPos", Map({x: 0, y: 0}));

    default:
      return state;
  }
}

function setPanels(state) {
  // if (state.get("context") == "water_pallet")
  return state;
}

function clearContext(state, oldContext) {
  if (state.get("context") !== oldContext) return state;
  return setContext(state, "");
}

function setContext(state, context, title="") {
  return state.set("title", title)
              .set("context", context);
}

export function getViewContext(state) {
  return state.get("context", "");
}

export function getViewTitle(state) {
  return state.get("title", "");
}

export function getContextualMenu(state) {
  return Map({
    active: state.get("contextualMenuActive"),
    items: state.get("contextualMenuItems"),
    pos: state.get("contextualMenuPos")
  })
}